module.exports = __webpack_public_path__ + "media/images/gallery/constellations/sextans/sex_lines-f8cb415f64101cada772a2f0fc80e981.gif";